export function isMobile() {
  return !!navigator.userAgent.match(/[Android|BlackBerry|iPhone|iPod|IEMobile|(Opera Mini)]/i);
}

export function formatDate(fmt, date = new Date()) {
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'D+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    S: date.getMilliseconds(), // 毫秒
    Z: date.getTimezoneOffset(), //时区
  };
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  // tslint:disable-next-line: forin
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length),
      );
    }
  }
  return fmt;
}

export function compareInDate(startDate, endDate) {
  return Date.now() > new Date(startDate) && Date.now() < new Date(endDate);
}
